// @flow
import * as React from 'react';
import { useUniqueClosesByAgentId } from './hooks/use-unique-closes-by-agent-id';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { DashboardCard } from '../../dashboard-card';
import moment from 'moment/moment';
import { TrendUpIcon, TrendDownIcon } from '@phosphor-icons/react';

type Props = {
  agentId?: string,
};
export const UniqueClosesCard = ({ agentId }: Props) => {
  const {current, previous, loading} = useUniqueClosesByAgentId(agentId);

  const rawPercent = (previous && isFinite(previous)) ? ((current ?? 0) - previous) / previous * 100 : 0;
  const percent = isFinite(rawPercent) ? rawPercent : 0;
  const trendColor = percent >= 0 ? '#13b362' : '#DE3124';

  return (
    <DashboardCard sx={{ alignItems: 'stretch' }}>
      <Typography variant={'h3'}>Unique Closes</Typography>
      <Typography variant={'caption'} color={'text.secondary'} mb={2}>
        {moment().startOf('month').format('MMM D')} - {moment().format('MMM D')}
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (<>
        <Stack direction={'row'} alignItems={'center'}>
          <Typography variant={'h1'} lineHeight={'1!important'} mr={1}>
            {current || 0}
          </Typography>
          {percent >= 0 ? <TrendUpIcon size={20} color={trendColor} /> : <TrendDownIcon size={20} color={trendColor} />}
          <Typography variant={'caption'} color={trendColor} ml={0.5}>
            {Math.round(percent)}%
          </Typography>
        </Stack>
        <Typography variant={'caption'} color={'#9a9a9a'} mt={1} >
          <i>{previous} in {moment().subtract(1, 'month').startOf('month').format('MMM D')} - {moment().subtract(1, 'month').format('MMM D')}</i>
        </Typography>
      </>)}
    </DashboardCard>
  );
};
